/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const QuoteSectionId = Object.freeze({
	DIRECT_WORK: "direct_work",
	NON_DIRECT_WORK: "non_direct_work",
	INFO_GATHERING: "info_gathering",
	BOOK_WRITING: "book_writing",
	TRAVEL: "travel",
	OTHER_MEETINGS: "other_meetings",
	OTHER_EXPENSES: "other_expenses",
})

export const DEFAULT_QUOTE_SECTION_ID = QuoteSectionId.OTHER_EXPENSES

export const QuoteSections = [
	{id: QuoteSectionId.DIRECT_WORK, title: "Direct Work"},
	{id: QuoteSectionId.NON_DIRECT_WORK, title: "Non-Direct Work"},
	{id: QuoteSectionId.BOOK_WRITING, title: "Book Writing"},
	{id: QuoteSectionId.INFO_GATHERING, title: "Info Gathering"},
	{id: QuoteSectionId.TRAVEL, title: "Travel"},
	{id: QuoteSectionId.OTHER_MEETINGS, title: "Other Meetings"},
	{id: QuoteSectionId.OTHER_EXPENSES, title: "Other Expenses"},
]

export const VisibleQuoteSections = QuoteSections.filter(sectionItem => {
	return sectionItem.id !== QuoteSectionId.OTHER_EXPENSES
})

export const LegacyQuoteSectionId = Object.freeze({
	CORE_TLSW: "core_tlsw",
	INFO_GATHERING: "info_gathering",
	BOOK_WRITING: "book_writing",
	TRAVEL_COSTS: "travel_costs",
	ADDITIONAL_COSTS: "additional_costs",
})

const _quoteSectionIdsMap = QuoteSections.reduce((acc, sectionItem) => {
	acc[sectionItem.id] = true
	return acc
}, {})

export const resolveQuoteSectionId = (sectionId) => {
	return _quoteSectionIdsMap[sectionId] ? sectionId : DEFAULT_QUOTE_SECTION_ID
}

export const resolveVisibleQuoteSectionId = (sectionId) => {
	let resolvedSectionId = resolveQuoteSectionId(sectionId)
	if (resolvedSectionId === QuoteSectionId.OTHER_EXPENSES) {
		return QuoteSectionId.NON_DIRECT_WORK
	}
	return resolvedSectionId
}
